const BASE_PUBLIC_URL = `${process.env.PUBLIC_URL}`;
export const GOVT_IMG = BASE_PUBLIC_URL + "/img/govtimg.svg";
export const PMB_IMG = BASE_PUBLIC_URL + "/img/pmbiimg.png";
export const PMBI_IMAGE = BASE_PUBLIC_URL + "/img/icon/pmbi_header.svg";
export const PRIYOJNA_IMG = BASE_PUBLIC_URL + "/img/icon/bhartiya_janaushadhi_priyojna.svg";
export const PDFICON_IMG = BASE_PUBLIC_URL + "/img/pdficon.png";
export const PROFILEICON_IMG = BASE_PUBLIC_URL + "/img/profileicon.png";
export const USERICON_IMG = BASE_PUBLIC_URL + "/img/usericon.png";
export const ICON_IMG = BASE_PUBLIC_URL + "/img/icon.svg";
export const HOMEICON_IMG = BASE_PUBLIC_URL + "/img/homeicon.png";
export const SEARCHICON_IMG = BASE_PUBLIC_URL + "/img/searchicon.png";
export const TOPARROWICON_IMG = BASE_PUBLIC_URL + "/img/toparrowicon.png";
export const UPLOAD_ICON_IMG = BASE_PUBLIC_URL + "/img/upload_icon_text.svg";
export const RESUME_PMBI_IMG = BASE_PUBLIC_URL + "/img/pmbi_pdf.png";


/********************** HEADER CLOSE**************************/
/********************** HEADER Image**************************/
export const GOVT_IMG_1 = BASE_PUBLIC_URL + "/img/govtimg_1.svg";
export const AAJADI_IMG_1 = BASE_PUBLIC_URL + "/img/ajadi_1.svg";
export const G2INDIA_IMG_1 = BASE_PUBLIC_URL + "/img/G20_India_1.png";
export const SWACHH_BHARAT_IMG = BASE_PUBLIC_URL + "/img/Swacch-Bharat-Color.svg";
export const PRIYOJNA_IMG_1 = BASE_PUBLIC_URL + "/img/bhartiya_janaushadhi_priyojna_2.svg";
export const PMBI_IMAGE_1 = BASE_PUBLIC_URL + "/img/pmbi_header_1.svg";
/********************** HEADER Image**************************/
export const CAROUSEL_IMG = BASE_PUBLIC_URL + "/img/carouselimg.png";
export const SUGAM_MOBILE_APP = BASE_PUBLIC_URL + "/img/SUGAM-MOBILE-APP-WEBSITE-BANNER.jpg";
/********************** CAROUSEL CLOSE**************************/

export const VISION_IMG = BASE_PUBLIC_URL + "/img/vision_img.png";
export const BHAGWANT_IMG = BASE_PUBLIC_URL + "/img/bhagwantimg.png";
export const MANSUKHA_IMG = BASE_PUBLIC_URL + "/img/manshukhaimg.png";
export const HOME_IMG = BASE_PUBLIC_URL + "/img/homeimg.png";
export const GIRLICON_IMG = BASE_PUBLIC_URL + "/img/girlicon.png";
export const NEWS_IMG = BASE_PUBLIC_URL + "/img/newsimg.png";
export const NEWS_IMG1 = BASE_PUBLIC_URL + "/img/newsimg1.png";
export const NEWS_IMG2 = BASE_PUBLIC_URL + "/img/newsimg2.png";
export const NEWS_IMG3 = BASE_PUBLIC_URL + "/img/newsimg3.png";
export const VIDEO_IMG1 = BASE_PUBLIC_URL + "/img/vdo1.png";
export const VIDEO_IMG2 = BASE_PUBLIC_URL + "/img/vdo2.png";
export const VIDEO_IMG3 = BASE_PUBLIC_URL + "/img/vdo3.png";
export const ARROW_PREV = BASE_PUBLIC_URL + "/img/arrow_left.png";
export const ARROW_NEXT = BASE_PUBLIC_URL + "/img/arrow_right.png";
export const JANA_LOGO_P_6 = BASE_PUBLIC_URL + "/img/jana_p_logo_6.png";
export const JANA_LOGO_P_1 = BASE_PUBLIC_URL + "/img/jana_p_logo_1.png";
export const JANA_LOGO_P_2 = BASE_PUBLIC_URL + "/img/jana_p_logo_2.png";
export const JANA_LOGO_P_3 = BASE_PUBLIC_URL + "/img/jana_p_logo_3.png";
export const JANA_LOGO_P_4 = BASE_PUBLIC_URL + "/img/jana_p_logo_4.png";
export const JANA_LOGO_P_5 = BASE_PUBLIC_URL + "/img/jana_p_logo_5.png";
export const JANA_LOGO_P_7 = BASE_PUBLIC_URL + "/img/jana_p_logo_7.png";
export const SUCCESSTORY_1 = BASE_PUBLIC_URL + "/img/successtory_1.png";
export const SUCCESSTORY_2 = BASE_PUBLIC_URL + "/img/successtory_2.png";
export const SUCCESSTORY_3 = BASE_PUBLIC_URL + "/img/successtory_3.png";
export const GALLERY_1 = BASE_PUBLIC_URL + "/img/gallery_1.png";
export const GALLERY_2 = BASE_PUBLIC_URL + "/img/gallery_2.png";
export const GALLERY_3 = BASE_PUBLIC_URL + "/img/gallery_3.png";

/********************** HOME PAGE CLOSE**************************/
export const LOGINFLOW_IMG = BASE_PUBLIC_URL + "/img/loginimg1.png";
export const BANNER_IMG = BASE_PUBLIC_URL + "/img/image-1920x506.jpg";
/********************** FORGOTPASSWORD CLOSE**************************/
export const FB_IMG1 = BASE_PUBLIC_URL + "/img/fb_1.svg";
export const TWITTER1_IMG = BASE_PUBLIC_URL + "/img/twitter_icon.png";
export const YOUTUBE1_IMG = BASE_PUBLIC_URL + "/img/youtube_1.svg";

/********************** SOCIALPAGE CLOSE**************************/
export const SCANNER_IMG = BASE_PUBLIC_URL + "/img/scannerimg.jfif";
export const GOOGLE_IMG = BASE_PUBLIC_URL + "/img/googleimg.png";
export const APP_IMG = BASE_PUBLIC_URL + "/img/appimg.png";
export const LEFTARROW_IMG = BASE_PUBLIC_URL + "/img/leftarrow.png";
export const BACKARROW_IMG = BASE_PUBLIC_URL + "/img/icon/arrow-left.png";
export const CALLICON_IMG = BASE_PUBLIC_URL + "/img/callicon.png";
export const NUMBERICON_IMG = BASE_PUBLIC_URL + "/img/numbericon.png";
export const LOGOICON_IMG = BASE_PUBLIC_URL + "/img/logoicon.png";
export const EMAILICON_IMG = BASE_PUBLIC_URL + "/img/emailicon.png";
export const ADDRESSICON_IMG = BASE_PUBLIC_URL + "/img/Addressicon.png";
export const FACEBOOKICON_IMG = BASE_PUBLIC_URL + "/img/facebookicon.png";
export const YOUTUBEICON_IMG = BASE_PUBLIC_URL + "/img/youtubeicon.png";
export const TWITTERICON_IMG = BASE_PUBLIC_URL + "/img/twittericon.png";
export const BACKTOTOP_IMG = BASE_PUBLIC_URL + "/img/backtotop.png";
export const CHAT_ICON_IMG = BASE_PUBLIC_URL + "/img/chat-bot.svg";
export const CROSS_ICON_IMG = BASE_PUBLIC_URL + "/img/cross.png";
export const LETTER_HEAD_IMG = BASE_PUBLIC_URL + "/img/letterhead_img.png";

/********************** FOOTER CLOSE**************************/
/******Button Icon*******/
export const HEADER_DOWN_ARROW =
  BASE_PUBLIC_URL + "/img/icon/header-down-arrow.svg";
export const RIGHTARROW = BASE_PUBLIC_URL + "/img/icon/arrow-right.svg";
export const LIST_RIGHT_ARROW = BASE_PUBLIC_URL + "/img/icon/serial_icon.svg";
export const CAPTCHA_IMAGE = BASE_PUBLIC_URL + "/img/captch-img-1.jpg";
export const CAPTCHA_REFRESH_ICON =
  BASE_PUBLIC_URL + "/img/icon/refresh-icon.svg";
export const INPUT_INFO_ICON = BASE_PUBLIC_URL + "/img/icon/info-icon.svg";
export const INPUT_PDF_ICON = BASE_PUBLIC_URL + "/img/icon/pdf_icon.png";
export const INPUT_CSV_ICON = BASE_PUBLIC_URL + "/img/icon/csv_icon.png";
// export const VIEW_PDF_ICON = BASE_PUBLIC_URL + "/img/viewpdf.png";
export const VIEW_PDF_ICON = BASE_PUBLIC_URL + "/img/pdf_png.png";
export const SENDBTN_ICON = BASE_PUBLIC_URL + "/img/send-button-icon.png";
/************Eye-icon************/
export const OPENEYE = BASE_PUBLIC_URL + "/img/icon/open-eye-icon.svg";
export const CLOSEEYE = BASE_PUBLIC_URL + "/img/icon/close-eye-icon.svg";
/***************File Upload******************/
export const FILE_INPUT = BASE_PUBLIC_URL + "/img/icon/fileupload.svg";
/**********************topbanner **************************/
export const LEFT_ARROW = BASE_PUBLIC_URL + "/img/leftarrow.png";
/********************** KendraRegistration **************************/
export const PDF_IMG = BASE_PUBLIC_URL + "/img/openpdf.png";
export const KENDRA_IMG = BASE_PUBLIC_URL + "/img/kendraimg.png";
export const INFO_IMG = BASE_PUBLIC_URL + "/img/infoimg.svg";
export const PFD_ICON = BASE_PUBLIC_URL + "/img/pdf.png";

/**********************Admin Layout**************************/
export const ADMIN_LOGIN_IMG = BASE_PUBLIC_URL + "/img/adminloginimg.png";
export const OSHADHI_IMG = BASE_PUBLIC_URL + `/img/oshadhiimg.svg`;
export const ADMIN_PROFILE = BASE_PUBLIC_URL + "/img/adminimage.png";
export const ADMIN_SIDEBAR_USER = BASE_PUBLIC_URL + "/img/icon/admin-sidebar2.svg";
export const ADMIN_DASHBOARD = BASE_PUBLIC_URL + "/img/icon/home.svg";
export const ADMIN_SIDEBAR_HR =
  BASE_PUBLIC_URL + "/img/icon/admin-sidebar3.svg";
export const ADMIN_LOGO = BASE_PUBLIC_URL + "/img/admin-logo.png";
export const UPLOAD_IMAGE_DUMMY = BASE_PUBLIC_URL + "/img/image-374x386.jpg";
export const ADMIN_BELL_ICON =
  BASE_PUBLIC_URL + "/img/icon/admin-notification.svg";
export const ADMIN_MSG_ICON = BASE_PUBLIC_URL + "/img/icon/admin-msg.svg";
export const PMBI_ADMIN_LOGO = BASE_PUBLIC_URL + "/img/icon/pmbi-toggle-img.svg";
export const ADMIN_VIEW_ICON = BASE_PUBLIC_URL + "/img/icon/admin-view-icon.svg";
export const ADMIN_UP_ICON = BASE_PUBLIC_URL + "/img/Up.svg";
export const ADMIN_DOWN_ICON = BASE_PUBLIC_URL + "/img/Down.svg";
export const ADMIN_DELETE_ICON = BASE_PUBLIC_URL + "/img/icon/deleteicon.svg";
export const ADMIN_EDIT_ICON = BASE_PUBLIC_URL + "/img/icon/admin-edit-icon.svg";
export const ADMIN_IMAGE_DELETE_ICON = BASE_PUBLIC_URL + "/img/icon/imagedelete.svg";
export const ADMIN_IMAGE_UPDATE_ICON = BASE_PUBLIC_URL + "/img/icon/updateImage.svg";

export const ADMIN_TEAM_DRAG = BASE_PUBLIC_URL + "/img/icon/dragteam.svg";

export const ADMIN_DOWN_ARRO =
  BASE_PUBLIC_URL + "/img/icon/admin-down-arro.svg";
export const ADMIN_VIEW_REMARK = BASE_PUBLIC_URL + "/img/icon/view-remark.svg";

/**********************Modal **************************/

/********************button icon***********************/
export const REJECTED_IMG = BASE_PUBLIC_URL + "/img/rejected.png";
export const HOLD_IMG = BASE_PUBLIC_URL + "/img/admin-hold.png";
export const APPROVED_IMG = BASE_PUBLIC_URL + "/img/approvedimg.png";
export const PAYMENT_DONE = BASE_PUBLIC_URL + "/img/paymentdonegif.gif";
export const ADD_PRODUCT_IMG = BASE_PUBLIC_URL + "/img/productadd.png";
export const ADD_LOCATOR_IMG = BASE_PUBLIC_URL + "/img/locator.png";
export const ADD_KENDARA_IMG = BASE_PUBLIC_URL + "/img/addkendra.png";
export const ADD_DEBARRED_IMG = BASE_PUBLIC_URL + "/img/debarrdedlist.png";
/********************button icon***********************/
export const PLUS_ICON = BASE_PUBLIC_URL + "/img/icon/plus_icon.png";
export const ADMIN_PLUS_ICON =
  BASE_PUBLIC_URL + "/img/icon/admin-plus-icon.svg";

/**********************User Layout  **************************/
export const USER_OS_LOGO = BASE_PUBLIC_URL + "/img/oshadhiimg.png";
export const USER_MINI_LOGO = BASE_PUBLIC_URL + "/img/mini_logo.jpg";
export const USER_PMBI_LOGO = BASE_PUBLIC_URL + "/img/icon/pmbi-toggle-img.svg";
export const USER_HOME_ICON = BASE_PUBLIC_URL + "/img/icon/home-icon.svg";
export const KEY_ICON = BASE_PUBLIC_URL + "/img/icon/key-icon.svg";
export const CLOSE_ICON = BASE_PUBLIC_URL + "/img/icon/close-icon.svg";

export const USER_KENDRA_ICON =
  BASE_PUBLIC_URL + "/img/icon/applykendra-icon.svg";
export const USER_APPLICATOIN_ICON =
  BASE_PUBLIC_URL + "/img/icon/application-icon.svg";
export const USER_PHARMA_ICON =
  BASE_PUBLIC_URL + "/img/icon/pharmacist-icon.svg";
export const USER_TOP_PMBI_LOGO = BASE_PUBLIC_URL + "/img/pmbi-logo.png";
export const USER_BELL_ICON = BASE_PUBLIC_URL + "/img/icon/bell.svg";
export const USER_ALARM_ICON = BASE_PUBLIC_URL + "/img/icon/alarm.svg";
export const USER_PROFILE_ICON = BASE_PUBLIC_URL + "/img/user-profile.svg";
export const USER_PROFILE_IMG = BASE_PUBLIC_URL + "/img/user-img.png";

/********dashboard graph******/
export const PROFILE_IMG = BASE_PUBLIC_URL + "/img/profileimage.jpg";
export const CASH_IMG = BASE_PUBLIC_URL + "/img/cashcardimg.png";
/********MAP******************/
export const MAP_INFO_ICON = BASE_PUBLIC_URL + "/img/icon/info-red-icon.svg";

// ****************************forgatepasswordarrow*********************************
export const RIGHT_ICON = BASE_PUBLIC_URL + "/img/icon/right-arrow.svg";
// ****************************payment page *********************************
export const GREENRIGHT_IMG = BASE_PUBLIC_URL + "/img/rightgreen.svg";
export const DOWNLOAD_PDF_IMG = BASE_PUBLIC_URL + "/img/pdfimg.svg";
export const DOWNLOAD_ICON = BASE_PUBLIC_URL + "/img/downloadicon.svg";
// ****************************message page *********************************
export const CHAIRPERSON_IMG = BASE_PUBLIC_URL + "/img/chairperson_Img.png";
export const CEOPERSON_IMG = BASE_PUBLIC_URL + "/img/ceopersonimg.png";

// *****************************User status Icon*************************
export const USER_STATUS_ICON =
  BASE_PUBLIC_URL + "/img/icon/user-status-icon.svg";
export const USER_SUCCESS_ICON =
  BASE_PUBLIC_URL + "/img/icon/user-success-status-icon.svg";
export const USER_REJECT_ICON =
  BASE_PUBLIC_URL + "/img/icon/user-reject-icon.svg";
export const USER_PENDING_ICON =
  BASE_PUBLIC_URL + "/img/icon/user-pending-icon.svg";
// ***********************icon for status******************************
export const SUCCESS_ICON = BASE_PUBLIC_URL + "/img/icon/success-icon.svg";
export const PENDING_ICON = BASE_PUBLIC_URL + "/img/icon/pending-icon.svg";
export const REJECT_ICON = BASE_PUBLIC_URL + "/img/icon/reject-icon.svg";
export const PENDING_WHITE_ICON =
  BASE_PUBLIC_URL + "/img/icon/pending-white-icon.svg";
export const SUCCESS_WHITE_ICON =
  BASE_PUBLIC_URL + "/img/icon/success-white-icon.svg";
// *******************popupcrossbtn*******************************
export const POPUPCROSS_ICON =
  BASE_PUBLIC_URL + "/img/icon/popup-cross-btn.svg";

// *******************about us*******************************
export const ABOUTSIDE_IMG = BASE_PUBLIC_URL + "/img/aboutimg.png";
/*****************************Cheque Number**********************************/
export const CHEQUE_NUMBER_IMG = BASE_PUBLIC_URL + '/img/cheque.png';
/***************************Congratulation**********************************/
export const CONGRATULATION_IMG = BASE_PUBLIC_URL + '/img/icon/congratulation.svg';
export const PRINT_IMG = BASE_PUBLIC_URL + '/img/icon/print-icon.svg';
export const DOWNLOAD_IMG = BASE_PUBLIC_URL + '/img/icon/download-icon.svg';
/***************************rti images**********************************/
export const RTI_IMG = BASE_PUBLIC_URL + "/img/rtibtnimg.png";
/***************************tender images**********************************/
// export const TENDERPDFICON_IMG = BASE_PUBLIC_URL + "/img/tenderpdficon.png";
export const TENDERPDFICON_IMG = BASE_PUBLIC_URL + "/img/pdf_png.png";
export const LANGUAGEICON_IMG = BASE_PUBLIC_URL + "/img/languageimg.png";
export const KENDRASIDE_IMG = BASE_PUBLIC_URL + "/img/KENDRASIDE_IMG.png";
export const SUCCESS_GREEN_CHECK = BASE_PUBLIC_URL + "/img/icon/success-green-check-mark-icon.svg";

/***************************Upload banner images**********************************/
export const PAYMENTCANCLE_IMG = BASE_PUBLIC_URL + "/img/icon/paymentCancel.svg";
export const DOWNLOAD_ICONIMG = BASE_PUBLIC_URL + "/img/download_icon.svg";
export const WEBSITEMANGER_ICON = BASE_PUBLIC_URL + "/img/website-manager-icon.svg";
export const UPLOAD_PHOTO_DUMMYIMG = BASE_PUBLIC_URL + "/img/upload_dummy_photo.png";
/***************************pharma register banner images**********************************/
export const PHARMAREGISTRAGISTRATION_IMG = BASE_PUBLIC_URL + "/img/pharmaregisterimg.png";
/***************************organization chart img**********************************/
export const ORGANIZATIONCHART_IMG = BASE_PUBLIC_URL + "/img/organizationchart.png";
/***************************management imgages**********************************/
export const KUNDAN_IMG = BASE_PUBLIC_URL + "/img/KKSingh.png";
export const RAVIKANT_IMG = BASE_PUBLIC_URL + "/img/ravikant.png";
export const JPMISHARA_IMG = BASE_PUBLIC_URL + "/img/JPMishra.png";
export const SANDEEP_IMG = BASE_PUBLIC_URL + "/img/sandeep.png";
export const CEO_IMG = BASE_PUBLIC_URL + "/img/ceo.png";
export const LOCKESH_IMG = BASE_PUBLIC_URL + "/img/lokesh.png";
export const PRASHANT_IMG = BASE_PUBLIC_URL + "/img/prashant.png";
export const BHARAT_IMG = BASE_PUBLIC_URL + "/img/bharat.png";
// Information Icon
export const INFORMATION_ICON = BASE_PUBLIC_URL + "/img/icon/information-icon.svg";
export const CLOSESEARCH_ICON = BASE_PUBLIC_URL + "/img/icon/close-search.svg";
export const APP_NO_IMG = BASE_PUBLIC_URL + "/img/chate_question.svg";

//pdf 
export const HELLO = BASE_PUBLIC_URL + "/pdf/Updated_Tripartite_Agreement.pdf";
export const NEWSLETTER_IMG = BASE_PUBLIC_URL + "/img/newsletter_img.png";

//
export const NODATAFOUND = BASE_PUBLIC_URL + "/img/no-data-found.png";
export const DEFAULTIMG = BASE_PUBLIC_URL + "/img/DefaultImg.png";
export const PMBIFOOTERBTN = BASE_PUBLIC_URL + "/img/pmbi-logo.svg";
export const PMBIFOOTERCROSSBTN = BASE_PUBLIC_URL + "/img/pmbi-cross-logo.png";
// modi
export const MODI = BASE_PUBLIC_URL + "/img/modi_img.jpg";
export const AAJADI_IMG = BASE_PUBLIC_URL + "/img/ajadi.svg";
export const G2INDIA_IMG = BASE_PUBLIC_URL + "/img/G20_India.png";
export const AVTAR_IMG = BASE_PUBLIC_URL + "/img/messageAvtarimg.png";

export const CARDS_IMG = BASE_PUBLIC_URL + "/img/cardsimg.png";
export const FRAUD_IMG = BASE_PUBLIC_URL + "/img/fraud-img.png"
// export const FRAUD_IMG = BASE_PUBLIC_URL + "/img/march-event.jpg";
export const DISABILIT_ICON = BASE_PUBLIC_URL + "/img/disability.svg";
export const GALLERY_ICON_1 = BASE_PUBLIC_URL + "/img/G1.jpg";
export const GALLERY_ICON_2 = BASE_PUBLIC_URL + "/img/G2.jpg";
export const GALLERY_ICON_3 = BASE_PUBLIC_URL + "/img/G3.jpg";
export const MAPICON_IMG = BASE_PUBLIC_URL + "/img/mapicon.png";
export const LISTICON_IMG= BASE_PUBLIC_URL + "/img/listicon.png";
// map
export const green_pin = BASE_PUBLIC_URL + "/img/icon/map-green-pin.png";
export const red_pin = BASE_PUBLIC_URL + "/img/icon/map-red-pin.png";
export const orange_pin = BASE_PUBLIC_URL + "/img/icon/map-orange-pin.png";
export const green_circle_pin = BASE_PUBLIC_URL + "/img/icon/green-circle-pin.png";
export const red_circle_pin = BASE_PUBLIC_URL + "/img/icon/red-circle-pin.png";
export const orange_circle_pin = BASE_PUBLIC_URL + "/img/icon/map-orange-pin.png";
